import { useEffect, useState } from "react";
import axios from "axios";
import { CDM_URL, NURI_PARAM } from "../constants";
import { nuriIds } from "@graphic/constants/sats";
import { queryString } from "@/utils/queryString";

const useNuriDataLoader = (satIds,selectedEvent) => {
  const [nuriTableData, setNuriTableData] = useState();

  const convertDateFormat = tcaDate => {
    const date = new Date(tcaDate);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    const fetchNuriData = async () => {
      try {
        const params = {
          ids: satIds,
          limit: NURI_PARAM.LIMIT,
          page: 0,
          sort: selectedEvent,
          tcaStart: new Date().toISOString(),
          tcaEnd: new Date(
            new Date().getTime() + NURI_PARAM.INTERVAL
          ).toISOString(),
          dcaUpper: 10,
          option: "simple",
          log: "nuri"
        };

        const NuriUrl = `${CDM_URL}/cdm/recent`;
        const response = await axios.get(`${NuriUrl}?${queryString(params)}`);
        const nuriData = await response.data;

        const data = nuriData.conjunctions.map(data => {
          return {
            primaryID: data.PRIMARY_OBJECT_DESIGNATOR,
            primaryName: data.PRIMARY_OBJECT_NAME,
            secondaryID: data.SECONDARY_OBJECT_DESIGNATOR,
            secondaryName: data.SECONDARY_OBJECT_NAME,
            tca: convertDateFormat(data.TCA),
            dca: (data.MISS_DISTANCE / 1000).toFixed(3)
          };
        });

        setNuriTableData(data);
      } catch (error) {
        console.error("Error fetching Nuri data: ", error);
      }
    };
    fetchNuriData();
  }, [selectedEvent]);

  return nuriTableData;
};

export default useNuriDataLoader;
